module.exports = __webpack_public_path__ + "img/avp_bck_alt_tablet@2x.bc2b612.webp";